<template>
  <FormMultiSelect :options="accountLocationLookup" :value="value" @input="$emit('input', $event)" />
</template>

<script>
import { mapState } from "vuex"

export default {
  name: 'AccountLocationMultiSelect',
  model: {
    event: 'input'
  },
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    activeOnly: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      accountLocations: state => state.account.accountLocations
    }),
    accountLocationLookup() {
      return (this.accountLocations || []).filter(location => location.isActive || !this.activeOnly).map(location => {
        return {
          name: location.name,
          value: location.id,
          colour: location.highlightColour
        }
      })
    }
  },
}
</script>